<template>
    <div class="banner">
        <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="item in bannerList" :key="item.id">
                <img :src="item.imgUrl" />
            </van-swipe-item>
        </van-swipe> -->

        <img :src="configImg" alt="" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            bannerList: [],
            configImg: '',
        };
    },
    computed: {
        ...mapGetters(['defaultInfo']),
    },
    created() {
        const { config } = this.defaultInfo;
        this.configImg = config.shareImg;
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.banner {
    width: 100%;
    text-align: center;
    vertical-align: middle;

    img {
        width: 100%;
    }
}
</style>